<script setup>
import ClickableCell from '@/components/lists/ClickableCell';
// Props
const props = defineProps({
  ladder: {
    type: Object,
    default: () => null
  }
});
</script>

<template>
  <clickable-cell
      icon="mdi-ladder"
      tone="ladder"
      class="mb-3"
      :to="{ name: 'LadderDetail', params: { ladderId: ladder.id } }"
      :title="ladder.name"
      :subtitle="ladder.teamCount + ' competitors'"
  />
</template>
